import React from 'react';
import { LightBulbIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ExpandableCallout from '../../../components/playbooks/ExpandableCallout';

const EmployerBrandFinalThoughts = () => (
  <div className="space-y-8">
    <PlaybookSection title="Final Thoughts" icon={<LightBulbIcon className="h-7 w-7 text-primary-light" />} heading>
      <PlaybookCard>
        <div className="p-4 border-l-4 border-primary-light bg-gray-900/30 rounded-r-lg mb-6">
          <p className="text-gray-300 mb-2">
            Building an authentic employer brand is not a one-time project.
          </p>
          <p className="text-gray-300 mb-2">
            It's a continuous journey of discovery, implementation, and improvement.
          </p>
          <p className="text-gray-300 mb-2">
            Remember: The goal is not to be perfect, but to be authentic.
          </p>
          <p className="text-gray-300 font-semibold">
            Keep going! 🚀
          </p>
        </div>

        <h3 className="text-2xl font-semibold text-white mb-4">Key Takeaways</h3>
        <ul className="space-y-2">
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Your EVP should reflect reality, not aspiration</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Transparency attracts the right talent and repels the wrong fit</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Regular feedback and iteration keep your EVP authentic</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Metrics help you track and improve your employer brand</span>
          </li>
        </ul>

        <h3 className="text-2xl font-semibold text-white mt-8 mb-4">Next Steps</h3>
        <ul className="space-y-2">
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Start with your internal survey</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Schedule your first 1:1 interviews</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Set up your metrics dashboard</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light mr-2">—</span>
            <span className="text-gray-300">Create your first team update</span>
          </li>
        </ul>

        <ExpandableCallout type="info" title="Need Help?" defaultOpen={true}>
          <p className="text-gray-300 mb-4">
            We're here to support you on your journey to building an authentic employer brand. Book a free 30-minute coaching call to discuss your specific needs and challenges.
          </p>
          <a 
            href="https://calendly.com/open-org/doing-culture-right-discovery"
            className="inline-flex items-center text-primary hover:text-primary-light"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book Your Free Session
          </a>
        </ExpandableCallout>
      </PlaybookCard>
    </PlaybookSection>
  </div>
);

export default EmployerBrandFinalThoughts; 